
import axios from 'axios';
import { mapActions, mapMutations } from 'vuex';
import ToastContainer from '../lightbox/ToastContainer.vue';
import ArticleCard from './ArticleCard.vue';
import ArticleReport from './lightbox/ArticleReport.vue';
import ArticleReportResponse from './lightbox/ArticleReportResponse.vue';
import ArticleShare from './lightbox/ArticleShare.vue';
import ArticleLoadingContainer from '../loading/container/ArticleLoadingContainer.vue';

export default {
    name: "article-channel-container",
    props: {
        channel_id: Number,
        cat_id: Number,
        channel_name: String
    },
    components: {
        ArticleCard,
        ArticleReport,
        ArticleShare,
        ArticleReportResponse,
        ToastContainer,
        ArticleLoadingContainer
    },
    data() {
        return {
            article_page: 3,
            pa_count: 1,
            channel_data: [
                { title: "美食攻略", channel_id: 1 },
                { title: "旅遊文章", channel_id: 2 },
                { title: "3C文章", channel_id: 3 },
                { title: "親子文章", channel_id: 4 },
                { title: "影視文章", channel_id: 5 },
                { title: "熱門文章", channel_id: 6 },
                { title: "健康文章", channel_id: 7 },
                { title: "職涯文章", channel_id: 8 },
                { title: "身心靈文章", channel_id: 9 },
                { title: "住家文章", channel_id: 10 },
                { title: "寵物文章", channel_id: 11 },
                { title: "開車車文章", channel_id: 12 },
            ],
            more_article_count: 0,
            isScroll: false
        }
    },
    methods: {
        ...mapActions('article', [
            'getArticleData',
            'getMoreArticleData',
            'setMoreData'
        ]),
        ...mapMutations('article', [
            'toogleLazyLoadingStatus'
        ]),
        clickToGetMoreArticle() {
            const vm = this;
            vm.toogleLazyLoadingStatus();
            vm.setMoreArticleData().then((res) => {
                if (res.status == 200) {
                    const tmpResdata = res.data;
                    if (tmpResdata.success) {
                        vm.setMoreData(tmpResdata.data.articles);
                    }
                }
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                vm.isScroll = false;
                vm.article_page = vm.article_page + 1;
                vm.pa_count = vm.pa_count + 1;
                vm.more_article_count = vm.more_article_count + 1;
            });
        },
        setMoreArticleData() {
            const vm = this;
            const token = vm.member_token ? vm.member_token : "";
            const params = {
                channel_id: vm.channel_id,
                page: vm.article_page,
                page_size: 6,
                with_author: 1,
                with_images: 1,
                member_token: token
            };
            return axios({
                method: "get",
                url: "https://www.pixnet.net/mainpage/api/channel/getSuggestArticle2",
                params: params,
                headers: {
                    "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
                }
            });
        },
        openToast() {
            this.$refs.toast_box.openToastElement();
        },
        handleScroll() {
            const vm = this;
            let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            let clientHeight = document.documentElement.clientHeight;
            const tmpFooterTag = document.querySelector("footer");
            const tmpFooterOffsetTop = tmpFooterTag.offsetTop - clientHeight;
            if (currentScroll > tmpFooterOffsetTop) {
                if (!vm.isScroll) {
                    vm.isScroll = true;
                    vm.clickToGetMoreArticle();
                }
            }
        }
    },
    computed: {
        article_data() {
            return this.$store.state.article.article_data;
        },
        member_token() {
            return this.$store.state.login.pix_member_token.member_token;
        },
        article_model_id_index() {
            return this.$store.state.article.model_id_index;
        },
        title_text() {
            return this.channel_data.find(e => e.channel_id == this.channel_id).title;
        },
        article_channel_id() {
            if (this.cat_id != 0 && this.cat_id != "" && this.cat_id != undefined) {
                return this.cat_id;
            } else {
                return this.channel_id
            }
        },
        lazy_loading_status() {
            return this.$store.state.article.lazy_loading_status;
        }
    },
    watch: {
        cat_id: async function () {
            const token = this.member_token ? this.member_token : "";
            const params = {
                channel_id: this.article_channel_id,
                page: 1,
                page_size: 6,
                with_author: 1,
                with_images: 1,
                member_token: token
            };
            await this.getArticleData(params);
        }
    },
    async mounted() {
        const vm = this;
        window.addEventListener("scroll", vm.handleScroll);
        const token = this.member_token ? this.member_token : "";
        const params = {
            channel_id: this.article_channel_id,
            page: 1,
            page_size: 18,
            with_author: 1,
            with_images: 1,
            member_token: token
        };
        await this.getArticleData(params);
        // console.log(this.article_data)
    },
    destroyed() {
        const vm = this;
        window.removeEventListener("scroll", vm.handleScroll);
    }
}
